import { useNavigate } from 'hooks';
import { Button } from 'components/button';
import { Flex } from 'components/flex';
import * as Styles from './styles';

export function CompletionAlertCard({ alert, close }: {
  alert: { eventId: number; eventName: string; sessionName: string; isCurrentSession: boolean };
  close: () => void;
}) {
  const navigate = useNavigate();
  return <div style={{ padding: 16, borderBottom: '1px solid #e8e8e8' }}>
    <Flex column gap={8}>
      <Styles.Title>Pending sale to be completed</Styles.Title>
      <strong>{alert.eventName}</strong>
      {alert.isCurrentSession ? <>
        <p>Finish the saved sale in Receipts with a manager PIN.</p>
        <Button text="Open Receipts" onClick={() => { close(); navigate('/products/' + alert.eventId + '/receipts'); }} />
      </> : <p>On the POS signed in as {alert.sessionName}, open Receipts and finish the saved sale with a manager PIN.</p>}
    </Flex>
  </div>;
}
